<a href="#" 
    class="list-group-item clearfix"
    (click)="onSelect()">
    <div class="pull-left">
        <h4 class="list-group-item-heading">{{recipe.name}}</h4>
        <p class="list-group-item-text">{{recipe.description}}</p>
    </div>
    <span class="pull-right">
        <img 
            [src]="recipe.imagePath" 
            alt="{{recipe.name}}" 
            class="img-responsive" 
            style="max-height: 50px;">
    </span>
</a>